// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__1Z1WP","Image":"Card_Image__fEQeG","Info":"Card_Info__4ESQ1","Title":"Card_Title__1a18q","Description":"Card_Description__Sqq1H","Buttons":"Card_Buttons__3dBKI"};